import { useNavigate, useSearchParams } from 'react-router-dom';
import { safeReturnTo } from 'utils/authReturn';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn, userNotFound } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(userNotFound ? '/pages/access-denied' : (safeReturnTo(params.get('returnTo')) ?? DASHBOARD_PATH), { replace: true });
    }
  }, [isLoggedIn, userNotFound, navigate, params]);

  return children;
}
